import { useState } from "react";

export function useLoading() {
    const [crewsLoading, setCrewsLoading] = useState(false);
    const [unassignedLoading, setUnassignedLoading] = useState(false);
    const [transfersLoading, setTransfersLoading] = useState(false);
    return { crewsLoading, setCrewsLoading, unassignedLoading, setUnassignedLoading, transfersLoading, setTransfersLoading }
}